<h6 class="mb-4 text-uppercase text-muted">
  Step <span id="currentWizardStep">{{ stagePosition }}</span> of <span id="totalWizardSteps">{{ totalStages }}</span>
</h6>
